import { Trans } from '@lingui/macro';
import * as React from 'react';

export const inputDateMinorErrorMessage = (
  <Trans>
    La personne doit être majeure
  </Trans>
);
